var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Close } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import Divider from '../Divider';
import Text from '../Text';
import { useCallback } from 'react';
import colors from '../../themes/colors';
var StyledBox = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n"])));
var ModalTitleBar = function (_a) {
    var title = _a.title, onClose = _a.onClose;
    var onCloseClick = useCallback(function (e) {
        onClose === null || onClose === void 0 ? void 0 : onClose(e, 'closeButton');
    }, [onClose]);
    var closeButton;
    if (onClose) {
        closeButton = (_jsx(IconButton, __assign({ sx: { padding: 0 }, onClick: onCloseClick }, { children: _jsx(Close, { sx: { color: colors.neutral100 } }) })));
    }
    return (_jsxs(_Fragment, { children: [_jsxs(StyledBox, { children: [typeof title === 'string' ? _jsx(Text, __assign({ variant: "h6" }, { children: title })) : title, closeButton] }), _jsx(Divider, { margin: 0 })] }));
};
export default ModalTitleBar;
var templateObject_1;
